import { getAuth, signInWithPopup, GoogleAuthProvider } from "firebase/auth";
import { app } from "../../firebase"; // Use the existing Firebase initialization
import '../../App.css';
import './Auth.css';
import googleLogo from './googleLogo.svg';

const auth = getAuth(app);

const signInWithGoogle = () => {
    const provider = new GoogleAuthProvider();

    signInWithPopup(auth, provider)
        .then(async (result) => {
            // FirebaseContext handles everything.
        })
        .catch((error) => {
            console.error("Error signing in: ", error);
        });
};

export const Auth = () => {
    return (
      <div className="App">
        <button className="button" onClick={signInWithGoogle}>
        <img src={googleLogo} alt="Google Sign In" />
        <span className="buttonText">Continue with Google</span>
        </button>
      </div>
    );
  }